


















































































































































import Component from 'vue-class-component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { PersonalDetails } from '@/models/form/PersonalDetails.model';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Getter, Mutation } from 'vuex-class';
import MockData from '@/globals/mock';
import { FORM101_DATA, FORM101_META_DATA, FORM_READ_ONLY_MODE, SET_FORM101_DATA } from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { Utils } from '@/globals/Utils';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';
import { MaritalStatus } from '@/models/form/enum/MaritalStatus';
import { Watch } from 'vue-property-decorator';


@Component({})
export default class PartnerDetails extends FeedbackComponent {

  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;

  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;

  public mockData: any = {};
  public partnerData!: PersonalDetails;

  public partnerBirthDate: Date | number | null = null;
  public partnerImmigrationDate: Date | number | null = null;
  public relativesAllowanceSum = 0;


  public created() {
    this.mockData = MockData.form101;
    this.partnerData = this.mockData.personalDetails;
    if (this.form101Data.partnerBirthDate) {
      this.partnerBirthDate = Utils.stringToDate('' + this.form101Data.partnerBirthDate);
    }
    if (this.form101Data.partnerImmigrationDate) {
      this.partnerImmigrationDate = Utils.stringToDate('' + this.form101Data.partnerImmigrationDate);
    }
    if (!this.form101Data.partnerIncome) {
      this.updateForm101Data(null, 'partnerIncomeOrBusiness');
      this.updateForm101Data(null, 'partnerOtherIncome');
    }
    this.relativesAllowanceSum = this.form101Data.taxYear > new Date().getFullYear() ?
        this.form101MetaData.relativesAllowanceNextYear : this.form101MetaData.relativesAllowanceCurrentYear;
  }


  @Watch('form101Data.partnerIncome')
  public partnerIncomeChanged(newVal: boolean, oldVal: boolean) {
    if (!newVal) {
      this.updateForm101Data(null, 'partnerIncomeOrBusiness');
      this.updateForm101Data(null, 'partnerOtherIncome');
    }
    this.updateForm101Data(newVal, 'partnerIncome');
  }

  @Watch('form101Data.maritalStatus')
  public martialStatusChanged(newVal: number, oldVal: number) {
    if (newVal !== MaritalStatus.MARRIED) {
      this.updateForm101Data(null, 'partnerIdNumber');
      this.updateForm101Data(null, 'partnerLastName');
      this.updateForm101Data(null, 'partnerFirstName');
      this.updateForm101Data(null, 'partnerBirthDate');
      this.updateForm101Data(null, 'partnerImmigrationDate');
      this.updateForm101Data(null, 'partnerIncome');
      this.updateForm101Data(null, 'partnerIncomeOrBusiness');
      this.updateForm101Data(null, 'partnerOtherIncome');
      this.updateForm101Data(null, 'partnerPassportNumber');
      this.partnerBirthDate = null;
      this.partnerImmigrationDate = null;
    }
    this.updateForm101Data(newVal, 'maritalStatus');
  }

  public updatePartnerIncome(dataModel: Form101DataModel) {
    this.updateForm101Data(dataModel.partnerIncomeOrBusiness, 'partnerIncomeOrBusiness');
    this.updateForm101Data(dataModel.partnerOtherIncome, 'partnerOtherIncome');
  }

  public updateDate(date: Date, property: string) {
    this.updateForm101Data(date ? Utils.dateToString(date) : date, property);
  }

  public updateForm101Data(newVal: any, property: string) {
    this.setForm101Data({ ...this.form101Data, [property]: newVal });
  }
}
